import { useMemo } from 'react';
import { useOrchestrator, FlowDef } from '@wix/gg-components/orchestrator';
import { StepParams } from 'types/steps';
import { useFlowBuilder } from './useFlowBuilder';

export function useStepperPosition() {
  const { currentStep } = useOrchestrator();
  const flow = useFlowBuilder();

  const { currentStepperIndex, totalStepperSteps } = useMemo(() => {
    const countableSteps = flow.filter(
      (item): item is FlowDef<StepParams> & { type: 'step' } =>
        item.type === 'step' && item.params?.countInStepper !== false,
    );

    if (!currentStep) {
      return {
        currentStepperIndex: 0,
        totalStepperSteps: countableSteps.length,
      };
    }

    let stepperIndex = 0;
    let foundCurrentStep = false;

    for (const item of flow) {
      if (item.type === 'step') {
        const isCountable = item.params?.countInStepper !== false;

        if (item.id === currentStep.id) {
          foundCurrentStep = true;
          if (isCountable) {
            stepperIndex++;
          }
          break;
        }

        if (isCountable) {
          stepperIndex++;
        }
      }
    }

    const currentStepperIndex = foundCurrentStep && stepperIndex > 0 ? stepperIndex - 1 : 0;

    return {
      currentStepperIndex,
      totalStepperSteps: countableSteps.length,
    };
  }, [flow, currentStep]);

  return {
    currentStep: currentStepperIndex,
    totalSteps: totalStepperSteps,
  };
}
